import PropTypes from "prop-types";

export const DropdownFieldPropTypes = {
  fieldName: PropTypes.string,
  fieldUID: PropTypes.string,
  fieldType: PropTypes.string,
  unit: PropTypes.object,
  dropdownValues: PropTypes.array,
};
